const DRAGGING = "dragging"
const LOGO_THEME = "logoTheme"
const TIMES = "times"
const SHOW_CLOCKS = "showClocks"

const initialState = {
  dragging: false,
  logoTheme: "white",
  showClocks: false,
  times: [
    {
      city: "New York",
      timeZone: "America/New_York",
      time: "",
    },
    {
      city: "London",
      timeZone: "Europe/London",
      time: "",
    },
    {
      city: "Dubai",
      timeZone: "Asia/Dubai",
      time: "",
    },
    {
      city: "Beijing",
      timeZone: "Asia/Shanghai",
      time: "",
    },
    {
      city: "Tokyo",
      timeZone: "Asia/Tokyo",
      time: "",
    },
    {
      city: "Melbourne",
      timeZone: "Australia/Melbourne",
      time: "",
    },
  ],
}

export const setDragging = bool => {
  return {
    type: DRAGGING,
    bool,
  }
}

export const setLogoTheme = string => {
  return {
    type: LOGO_THEME,
    string,
  }
}

export const setTimes = obj => {
  return {
    type: TIMES,
    obj,
  }
}

export const setShowClocks = bool => {
  return {
    type: SHOW_CLOCKS,
    bool,
  }
}

export default (state = initialState, action) => {
  switch (action.type) {
    case DRAGGING:
      return Object.assign({}, state, {
        dragging: action.bool,
      })
    case LOGO_THEME:
      return Object.assign({}, state, {
        logoTheme: action.string,
      })
    case SHOW_CLOCKS:
      return Object.assign({}, state, {
        showClocks: action.bool,
      })
    case TIMES:
      return {
        ...state,
        times: state.times.map((i, idx) =>
          i.city === action.obj.city
            ? {
                ...i,
                time: action.obj.time,
              }
            : i
        ),
      }

    default:
      return state
  }
}
